import React, { useEffect, useState, useCallback } from 'react';
import { getAllMarqueeTexts } from '../../../api/marqueeText.service';

const defaultMarqueeText =
  'Thoorgai 2.0 is Coming Soon! 🚀 More restaurants, cafés & exciting experiences await. Stay tuned for seamless event bookings! 🎉';

const OfferNewsMarque = () => {
  const [marqueeText, setMarqueeText] = useState(defaultMarqueeText);

  const fetchMarqueeText = useCallback(async () => {
    try {
      const response = await getAllMarqueeTexts();
      if (response.success) {
        const activeMarquee = response.data.find((item) => item.is_active);
        setMarqueeText(activeMarquee ? activeMarquee.text : defaultMarqueeText);
      } else {
        setMarqueeText(defaultMarqueeText);
      }
    } catch (error) {
      console.error('Error fetching marquee text:', error);
      setMarqueeText(defaultMarqueeText);
    }
  }, []);

  useEffect(() => {
    fetchMarqueeText();
  }, [fetchMarqueeText]);

  
  const cloneCount = (() => {
    const len = marqueeText.length;
    if (len < 20) return 8;
    if (len < 30) return 5;
    if (len < 40) return 4;
    if (len < 100) return 3;
    return 2;
  })();

  return (
    <div className='scroll-container bg-[#f6fcff]'>
      <div className='moving-wrapper'>
        {Array.from({ length: cloneCount }).map((_, index) => (
          <div key={index} className='moving-text' data-text={marqueeText}>
            {marqueeText}
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(OfferNewsMarque);
